export enum TimerUpdateSource {
    APP_JS_BRIDGE = "app_js_bridge",
    UPDATE_CART = "checkout_update_cart",
    FETCH_COUPONS = "pl_fetch_coupons",
    EVENT_STATUS_POLLING = "event_status_polling",
}

export enum SwiggySixesCommState {
    DISABLED = "DISABLED",
    SIX_HIT = "SIX_HIT",
    CONSECUTIVE_SIXES_HIT = "CONSECUTIVE_SIXES_HIT",
    EXPIRED = "EXPIRED",
}

export interface SwiggySixesCroutonAPIInfo {
    offerExpiresInSec: string | number;
    icon: string;
    states: {
        [key in SwiggySixesCommState]: string[];
    };
}

export interface SwiggySixesTickerTimer {
    enabled: boolean;
    minutes?: number;
    seconds?: number;
}

export interface SwiggySixesCroutonComms {
    enabled: boolean;
    croutonState?: SwiggySixesCommState;
    croutonComms?: string[];
    icon?: string;
}

export interface EventStatusEvent {
    live: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    offer_end_time_seconds: number;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    event_name: string;
}

export interface EventStatusData {
    events: EventStatusEvent[];
}

export interface EventStatusResponse {
    statusCode: number;
    statusMessage: string;
    data: EventStatusData;
}
